module.exports = function (cx8) {
  return !!cx8 && !!cx8.__CANCEL__;
};